<template>
  <div>
    <!--表格分析首页-->
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>告警分析</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card>
      <el-form>
        <el-row>
          <el-col :span="12">
            <el-form-item label="选择时间段">
              <el-date-picker
                v-model="dateRange"
                type="datetimerange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getSystemStatistics">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-row style="margin-top: 10px">
      <el-col :span="24">
        <el-card >
          <div id="alarmType" style="width: 800px; height: 378px"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px">
      <el-col :span="24">
        <el-card>
          <div id="alartTimeLine" style="width: 1000px;height: 400px"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import echarts from 'echarts'
export default {
  name: 'AlarmStatistic',
  data(){
    return {
      // 获取系统统计
      GetSystemStatistics:{
        "version": 1,
        "method": "other.SystemStatistics",
        "params": {
          "startTime":"",
          "endTime":""
        },
        "token": "",
        "id": 0
      },
      // 统计信息
      SystemStatistics:{
        "version": 1,
        "result": {
          "pointNum":100, // 警报点总数
          "alertedPointNum":1, // 发出警告警报点数(字段待修复)
          "breakdownPointNum":1, // 发生故障未修复警报点数
          "repairedPointNum":1, // 发生故障并修复的警报点数
          "alarmTypeCountList":[  // 告警类型统计
            {"alarmType":"电压过高", // 告警类型
              "count":"" // 个数
            },{"alarmType":"电流过载", "count":""
            },{"alarmType":"温度过高", "count":""
            },{"alarmType":"噪声过大", "count":""
            },{"alarmType":"空气污染", "count":""
            },
          ],
          // "alarmRecordCountArray":{int,int,...}      //size = 5
        },
        "id": 0
      },
      dateRange:'',// 时间范围
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      labelPosition:'left',
      numberOfAlarmPoint:100,// 警报点总数
      numberOfAlarmedAlarmPoint:23, // 发生告警的警报点总数
      chartRight:'',
      optionRight:  {
        title : {
          text: '告警类型统计',
          x:'center'
        },
        tooltip : {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient : 'vertical',
          x : 'left',
          data:['电压','声压','温度','湿度','气体']
        },
        toolbox: {
          show : true,
          feature : {
            mark : {show: true},
            dataView : {show: false, readOnly: false},
            magicType : {
              show: true,
              type: ['pie', 'funnel'],
              option: {
                funnel: {
                  x: '25%',
                  width: '50%',
                  funnelAlign: 'left',
                  max: 1548
                }
              }
            },
            restore : {show: false},
            saveAsImage : {show: false}
          }
        },
        calculable : false,
        series : [
          {
            name:'告警类型',
            type:'pie',
            radius : '55%',
            center: ['50%', '60%'],
            data:[
              // {value:335, name:'电压'},
              // {value:310, name:'声压'},
              // {value:234, name:'温度'},
              // {value:135, name:'湿度'},
              // {value:1548, name:'气体'}
            ]
          }
        ]
      },
      chartBottom:'',
      optionBottom: {
        title : {
          text: '告警次数按时间进行统计',
        },
        tooltip : {
          trigger: 'axis'
        },
        legend: {
          data:['最高气温']
        },
        toolbox: {
          show : true,
          feature : {
            mark : {show: true},
            dataView : {show: false, readOnly: false},
            magicType : {show: true, type: ['line', 'bar']},
            restore : {show: false},
            saveAsImage : {show: false}
          }
        },
        calculable : true,
        xAxis : [
          {
            type : 'category',
            boundaryGap : false,
            data : ['7.01','7.02','7.02','7.04','7.05','7.06','7.07']
          }
        ],
        yAxis : [
          {
            type : 'value',
            axisLabel : {
              formatter: '{value} 次'
            }
          }
        ],
        series : [
          {
            name:'发生次数',
            type:'line',
            data:[11, 11, 15, 13, 12, 13, 10],
            markPoint : {
              data : [
                {type : 'max', name: '最大值'},
                {type : 'min', name: '最小值'}
              ]
            },
            markLine : {
              data : [
                {type : 'average', name: '平均值'}
              ]
            }
          },
        ]
      }
    }
  },
  methods: {
    drawAll(){
      // 有了响应之后写到响应中
      this.optionRight.series[0].data = [];
      this.optionRight.legend.data = [];
      this.SystemStatistics.result.alarmTypeCountList.forEach((item) =>{
        let t = {value:'',name:''};
        t.value = item.count;
        t.name = item.alarmType;
        this.optionRight.series[0].data.push(t);
        this.optionRight.legend.data.push(item.alarmType);
      })
      this.optionBottom.xAxis[0].data = [];
      this.optionBottom.series[0].data = [];
      this.SystemStatistics.result.alarmRecordCountArray.forEach(item =>{
        this.optionBottom.xAxis[0].data.push(item.date.substring(0,10));
        this.optionBottom.series[0].data.push(item.count);
      })
      this.drawChart(this.chartRight,'alarmType',this.optionRight);
      this.drawChart(this.chartBottom,'alartTimeLine',this.optionBottom);
    },
    getSystemStatistics(){
      this.GetSystemStatistics.token = this.$store.state.token;
      for(let key in this.GetSystemStatistics.params){
        if(this.GetSystemStatistics.params[key] === ""){
          this.GetSystemStatistics.params[key] = null;
        }
      }
      console.log('获取表格数据请求');
      console.log(this.GetSystemStatistics);
      this.$axios.post(this.$mainUrl, this.GetSystemStatistics).then(res=>{
        console.log('获取表格数据请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.$message({
            type:'success',
            message:'获取表格数据成功'
          })
          this.SystemStatistics = res.data;
          this.drawAll();
        }else{
          this.$message({
            type:'error',
            message:'获取表格数据失败，' + res.data.error.message
          })
        }
      })
    },
    drawChart(chart,id,option){
      // 绘制表格
      console.log('绘制表格');
      chart = echarts.init(document.getElementById(id))
      chart.setOption(option);
    }
  },
  mounted () {
    this.getSystemStatistics();
  },
  // computed:{
  //   alarmRate(){
  //     return (this.numberOfAlarmedAlarmPoint/this.numberOfAlarmPoint * 100).toFixed(2);
  //   }
  // },
  watch:{
    dateRange(newValue, oldValue){
      this.GetSystemStatistics.params.startTime = newValue[0];
      this.GetSystemStatistics.params.endTime = newValue[1];
    }
  }
}
</script>

<style scoped>

</style>
<style>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: 99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>
